import { defineComponent as _defineComponent } from 'vue'
import { onMounted, reactive, watchEffect, onUnmounted, ref, onBeforeMount } from 'vue'
import PreviewDocumentComponent from './components/PreviewDocumentComponent.vue'
import DocumentTemplateSelectorComponent from './components/DocumentTemplateSelectorComponent.vue'
import SendingComponent from '@/components/billing/FacturaEDialog/components/SendingComponent.vue'
import {
  facturaEDialogModel,
  IFacturaEDialogModel
} from '@/components/billing/FacturaEDialog/types/FacturaEDialogTypes'
import CheckListComponent from '@/components/billing/FacturaEDialog/components/CheckListComponent.vue'
import useActionsFacturaEDialog from '@/components/billing/FacturaEDialog/composables/useActionsFacturaEDialog'


export default /*#__PURE__*/_defineComponent({
  __name: 'FacturaEDialog',
  props: {
  showDialog: {
    type: Boolean,
    required: true
  },
  invoiceId: {
    type: Number,
    required: true
  },
  invoiceDescription: {
    type: String,
    required: true
  },
  invoiceTemplates: {
    type: Boolean,
    required: true
  },
},
  emits: ['closeDialog'],
  setup(__props, { emit }) {

const props = __props;


const model: IFacturaEDialogModel = reactive({
  ...facturaEDialogModel,
  invoiceId: props.invoiceId,
  invoiceDescription: props.invoiceDescription
})
const loaded = ref<boolean>(false)
const {
  hasValidatorErrors,
  validate
} = useActionsFacturaEDialog(model)

const checkList = CheckListComponent
const steps = props.invoiceTemplates
  ? [DocumentTemplateSelectorComponent, PreviewDocumentComponent, SendingComponent]
  : [SendingComponent]

watchEffect(() => {
  if (model.step < 0 || model.step >= steps.length) {
    emit('closeDialog', hasValidatorErrors.value)
  }
})

function blockAppPointerEvents() {
  const app = document.querySelector('.v-application')
  const dialog = document.querySelector('.v-dialog__content.v-dialog__content--active')
  if (app && dialog) {
    app.classList.add('print-or-save-invoice-dialog')
    dialog.classList.add('print-or-save-invoice-dialog')
  }
}

function unblockAppPointerEvents() {
  const app = document.querySelector('.v-application')
  app!.classList.remove('print-or-save-invoice-dialog')
}

onBeforeMount(async () => {
  await validate()
  loaded.value = true
})
onMounted(() => blockAppPointerEvents())
onUnmounted(() => unblockAppPointerEvents())


return { __sfc: true,props, model, loaded, hasValidatorErrors, validate, emit, checkList, steps, blockAppPointerEvents, unblockAppPointerEvents }
}

})